export const env = () => {
    const host = window.location.hostname

    if ([ 'dev', 'v2.dev' ].some(e => host.startsWith(e))) {
        return 'development'
    }
    if ([ 'traction.technologyadvice.com', 'relay.cool', 'traction.advicebrands.com' ].some(e => host.startsWith(e))) {
        return 'production'
    }
    if (host.startsWith('platform.globaldemandpartners.com')) {
        return 'gdpProduction'
    }
    if ([ 'qa', 'qe' ].some(e => host.startsWith(e))) {
        // QE environment should not have recaptcha- this ensures the env variables don't change that.
        return null
    }
    return 'local'
}

export const recaptchaKeyProvider = () => {
    const environment = env()
    let key = null

    if (environment === 'development') {
        key = process.env.VUE_APP_RECAPTCHA_SITE_KEY_DEV
    } else if (environment === 'production') {
        key = process.env.VUE_APP_RECAPTCHA_SITE_KEY
    } else if (environment === 'local') {
        key = process.env.VUE_APP_RECAPTCHA_SITE_KEY_LOCAL
    } else if (environment === 'gdpProduction') {
        key = process.env.VUE_APP_RECAPTCHA_SITE_KEY_GDP
    }

    return key
}

export const recaptchaKey = recaptchaKeyProvider()

const pusherKeys = () => ({
    local: process.env.VUE_APP_PUSHER_KEY_LOCAL,
    development: process.env.VUE_APP_PUSHER_KEY_DEVELOPMENT,
    production: process.env.VUE_APP_PUSHER_KEY,
    gdpProduction: process.env.VUE_APP_PUSHER_KEY,
})

// QE has no environment name here; it shares the development Pusher app, as it does for delivery-portal.
export const pusherKey = () => pusherKeys()[env()] ?? process.env.VUE_APP_PUSHER_KEY_DEVELOPMENT
